import React from'react';import PropTypes from'prop-types';import {useIntl}from'react-intl';import {useNavigation,UtilityHeader,SignIn,MenuItem,Lang}from'@manulife/mux';import {useHistory}from'react-router-dom';import FormattedRichMessage from'../FormattedRichMessage/FormattedRichMessage.js';import usePathBuilder from'../../hooks/usePathBuilder.js';import {getFilteredRealms,HEADER_REALM_KEYS}from'../../utils/realmUtils.js';import ContactUs from'./MenuItems/ContactUs.js';import ManageId from'./MenuItems/ManageId.js';import useRealm from'../../hooks/useRealm.js';var Header = function Header(props) {
  var onLanguageToggle = props.onLanguageToggle,
    onLogout = props.onLogout,
    absoluteCiamDomain = props.absoluteCiamDomain,
    mainContentRef = props.mainContentRef,
    footerRef = props.footerRef,
    showLangToggle = props.showLangToggle,
    showContactUs = props.showContactUs,
    showRealmToggle = props.showRealmToggle,
    showManageId = props.showManageId;
  var intl = useIntl();
  var pathBuilder = usePathBuilder();
  var realm = useRealm();
  var history = useHistory();
  var _useNavigation = useNavigation(),
    isSignedIn = _useNavigation.isSignedIn;
  var handleChangeHeaderTab = function handleChangeHeaderTab(newRealm) {
    history.push(pathBuilder('/', true, {
      realm: newRealm
    }));
  };
  var realmItems = Object.values(getFilteredRealms(HEADER_REALM_KEYS)).map(function (realmValue) {
    return {
      id: realmValue,
      value: realmValue,
      label: intl.formatMessage({
        id: "shared.layout.utilityBar.realm.".concat(realmValue)
      })
    };
  });
  var headerTabs = !isSignedIn && showRealmToggle ? realmItems : [];
  return /*#__PURE__*/React.createElement(UtilityHeader, {
    headerTabs: headerTabs,
    selectedTab: realm,
    controlledSelectedTab: realm,
    onChangeHeaderTabs: handleChangeHeaderTab,
    mainContentRef: mainContentRef,
    footerRef: footerRef
  }, showContactUs && /*#__PURE__*/React.createElement(ContactUs, {
    absoluteCiamDomain: absoluteCiamDomain
  }), isSignedIn && /*#__PURE__*/React.createElement(SignIn, null, showManageId && /*#__PURE__*/React.createElement(ManageId, {
    absoluteCiamDomain: absoluteCiamDomain
  }), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: onLogout,
    label: /*#__PURE__*/React.createElement(FormattedRichMessage, {
      id: "shared.layout.utilityBar.signOut"
    })
  })), showLangToggle && /*#__PURE__*/React.createElement(Lang, {
    onClick: onLanguageToggle
  }));
};
var refShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
  current: PropTypes.instanceOf(Element)
})]) : {};
process.env.NODE_ENV !== "production" ? Header.propTypes = {
  onLanguageToggle: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  absoluteCiamDomain: PropTypes.string,
  mainContentRef: refShape,
  footerRef: refShape,
  showLangToggle: PropTypes.bool,
  showContactUs: PropTypes.bool,
  showRealmToggle: PropTypes.bool,
  showManageId: PropTypes.bool
} : void 0;
Header.defaultProps = {
  mainContentRef: null,
  footerRef: null,
  absoluteCiamDomain: '',
  showLangToggle: true,
  showContactUs: true,
  showRealmToggle: true,
  showManageId: true
};
var Header$1 = Header;export{Header$1 as default};